import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { SatelliteDatabaseEntry } from 'types';

export const getSatelliteDatabase = async (): Promise<
  SatelliteDatabaseEntry[]
> => {
  const { data } = await axios.get(`/api/satellites/database`);
  return data as SatelliteDatabaseEntry[];
};

type QueryFnType = typeof getSatelliteDatabase;

type UseSatelliteDatabaseOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSatelliteDatabase = ({
  config,
}: UseSatelliteDatabaseOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['satelliteDatabase'],
    queryFn: () => getSatelliteDatabase(),
  });
};
